module.exports = __webpack_public_path__ + "assets/img/30_700_big.ba63d938.jpg";